import { NEXT_JSONTREE_QUESTION, JSON_FORM, END } from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleNextJsonTreeQuestion<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (state.type !== JSON_FORM || action.type !== NEXT_JSONTREE_QUESTION) {
		return state
	}

	let updatedStack = state.answeredQuestionsStack
	const currentStackItem = updatedStack.find(
		item => item.id === state.currentQuestionTreeId,
	)

	if (action.nextQuestionId !== END) {
		currentStackItem!.currentQuestionId = action.nextQuestionId

		if (currentStackItem) {
			if (!currentStackItem.answers.includes(action.currentQuestionId)) {
				currentStackItem.answers.push(action.currentQuestionId)
			}
		} else {
			updatedStack.push({
				id: action.currentQuestionTreeId,
				answers: [action.currentQuestionId],
			})
		}
	} else {
		currentStackItem!.currentQuestionId = action.currentQuestionId
	}

	let updatedCurrentQuestionId =
		action.nextQuestionId !== END
			? action.nextQuestionId
			: action.currentQuestionId

	return {
		...state,
		currentQuestionId: updatedCurrentQuestionId,
		answeredQuestionsStack: updatedStack,
		formState: {
			...state.formState,
			...action.formData,
		},
	}
}
